import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { i18n } from "../../translate/i18n";

const StepCredenciais = ({ state, dispatch }) => {
  const setCampo = (campo) => (e) =>
    dispatch({ type: "SET_CAMPO", campo, valor: e.target.value });

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {i18n.t("whatsappOficialWizard.credenciais.titulo")}
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {i18n.t("whatsappOficialWizard.credenciais.descricao")}
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        type="password"
        label={i18n.t("whatsappOficialWizard.credenciais.token")}
        value={state.token}
        onChange={setCampo("token")}
        autoFocus
      />

      {/* Token de System User quase nunca traz o negocio por /me/businesses (a Meta
          nao expoe essa associacao para usuario de sistema), entao o campo aparece
          desde o inicio em vez de surgir depois como resgate de uma busca frustrada. */}
      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        label={i18n.t("whatsappOficialWizard.credenciais.businessIdManual")}
        helperText={i18n.t("whatsappOficialWizard.credenciais.businessIdAjuda")}
        value={state.businessIdManual}
        onChange={setCampo("businessIdManual")}
        error={Boolean(state.descoberta && state.descoberta.precisaBusinessIdManual)}
      />

      {state.descoberta && state.descoberta.precisaBusinessIdManual && (
        <Typography variant="body2" color="error" style={{ marginTop: 4 }}>
          {i18n.t("whatsappOficialWizard.credenciais.businessIdObrigatorio")}
        </Typography>
      )}

      <Accordion style={{ marginTop: 16 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">
            {i18n.t("whatsappOficialWizard.credenciais.comoGerar")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" color="textSecondary">
            {i18n.t("whatsappOficialWizard.credenciais.passos")}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default StepCredenciais;
